import React, { useEffect } from 'react';

interface SpinnerProps {
  size?: number;
  className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ size = 46, className = '' }) => {
  useEffect(() => {
    // Add keyframes animation to document if not already present
    if (!document.querySelector('#spinner-keyframes')) {
      const style = document.createElement('style');
      style.id = 'spinner-keyframes';
      style.textContent = `
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `;
      document.head.appendChild(style);
    }
  }, []);

  const spinnerStyle: React.CSSProperties = {
    width: size,
    height: size,
    border: '7px solid transparent',
    borderTop: '7px solid #232043',
    borderRight: '7px solid #232043',
    borderBottom: '7px solid #232043',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  };

  return <div className={className} style={spinnerStyle} />;
};

export default Spinner;